<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    width="70%"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="100px">
      <el-row   type="flex" style="flex-wrap:wrap">
        <el-col :span="24">
            <el-form-item label="套餐:" prop="">
              <span>{{ inputForm.cecUnmSets.nameCn }}</span>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="名称（英）:" prop="nameEn" :rules="[
                  {required: true, message:'名称（英）不能为空', trigger:'blur'}
                 ]">
              <!-- <span>{{ inputForm.nameEn }}</span> -->
              <el-input v-model="inputForm.nameEn"  placeholder="请填写名称（英）"  maxlength="64" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="名称（中）:" prop="">
              <span>{{ inputForm.nameCn }}</span>
           </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标签" prop="tagsIds"
            :rules="[
              {required: true, message:'标签不能为空', trigger:'blur'}
              ]">
              <tagSelect ref="tagSelectRef" :value="inputForm.tagsIds" @searchChange="handSelect" associationType="3"></tagSelect>
            </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="简介（英）:" prop="introductionEn"
                :rules="[
                  {required: true , message:'简介不能为空', trigger:'blur'}
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5 }" v-model="inputForm.introductionEn" placeholder="请填写简介内容"  maxlength="255"   ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="简介（中）:" prop=""
                :rules="[
                  {required: true , message:'简介不能为空', trigger:'blur'}
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5 }" v-model="inputForm.introduction" placeholder="请填写简介内容"     maxlength="255" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="功能空间:" prop="functionSpacePositionIds"
                :rules="[
                  {required: true, message:'功能空间不能为空', trigger:'blur'}
                 ]">
          <GridSelect
            ref="gridselectRef"
            title="选择功能空间"
            labelName = 'nameEn'
            :disabled="method==='view'"
            showType="table"
            labelValue = 'id'
            :value = "inputForm.functionSpacePositionIds"
            :limit="10"
            @getValue='(value) => {inputForm.functionSpacePositionIds=value}'
            :columns="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmFunctionalSpace/list"
            queryEntityUrl="/unmspace/cecUnmFunctionalSpace/queryById">
          </GridSelect>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showGallery == '0' ? 'opacity5' : ''">
            <el-form-item label="展览集:" prop="gallery"
                :rules="[
                  {required: inputForm.showGallery == '1' ? true : false , message:'展览集不能为空', trigger:'change'}
                 ]">
                <ImageUploadDraggableBtn
                  v-model="inputForm.gallery"
                  :draggable="true"
                  :itemActivityForm="true"
                  :ifSetUploadName="true" 
                  :ownerId="inputForm.id"
                  :uploadInfo="{type:'postionImage',title:'展览集' ,category: 'sets',categoryName: '套餐空间',tip:'请先输入英文名称',fileName: inputForm.nameEn}"
                  :disabled="false"
                  action="/unmfile/cecUnmFileupload"
                  tip="单个图片不要超过10M,可拖动列表行排序"
                  @updateChange="handImageList($event,'gallery')">
                </ImageUploadDraggableBtn>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" type="danger"  icon="el-icon-close" @click="visible = false">关闭</el-button>
      <el-button size="medium" type="success" icon="el-icon-check" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmProjectPositionService from '@/api/cecunmsetmealposition/cecUnmSetMealPositionService'
  import GridSelect from '@/components/gridSelect/setTagTableSet.vue'
  import ImageUploadDraggableBtn from '@/components/upload/ImageUploadDraggableBtn'
  import tagSelect from '@/components/select/tagSelect'
  import _ from 'lodash'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        tagList: [],
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          num: '',
          targetPrice: '',
          sort: '',
          type: '',
          functionalSpaceIds: '',
          functionSpacePositionIds: '',
          cecUnmSets: {
            nameCn: ''
          },
          gallery: [],
          introduction: '',
          introductionEn: '',
          tag: [],
          tagsIds: ''
        }
      }
    },
    components: {
      GridSelect,
      ImageUploadDraggableBtn,
      tagSelect
    },
    methods: {
      handSelect (e) {
        this.inputForm.tagsIds = e ? e.join(',') : ''
      },
      // 上传返回ids
      handImageList: _.debounce(function (e, type) {
        const that = this
        that.inputForm[type] = e.map(item => {
          let ritem = {
            // id: item.percentage === 0 ? '' : item.id,
            fileName: item.fileName,
            name: item.name,
            fileSize: item.size ? item.size : item.fileSize,
            url: item.url,
            filePath: item.filePath ? item.filePath : item.url,
            category: item.category ? item.category : 'setsMealPostion_' + type,
            description: item.description ? item.description : '',
            actorId: item.actorId,
            actorName: item.actorName,
            categoryName: item.categoryName,
            startTime: item.startTime,
            createDate: item.createDate,
            pixel: item.pixel
          }
          return ritem
        })
      }, 500),
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建套餐空间`
        } else if (method === 'edit') {
          this.title = '修改套餐空间'
        } else if (method === 'view') {
          this.title = '查看套餐空间'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.tagSelectRef.getTagCloud()
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmProjectPositionService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              // if (data.tagsIds && data.tagsIds !== '') {
              //   this.inputForm.tag = data.tagsIds.split(',')
              // }
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.inputForm.functionSpacePositionIds = this.$refs.gridselectRef.withoutList.map(item => item.id).join(',')
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmProjectPositionService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
::v-deep .el-tag:first-child{
  margin-left: 5px;
}
</style>
  
